<template>
  <el-container>
    <div class="t_neiban">
      <div class="t_b1banpic">
        <img src="../assets/image/zhaopin.jpeg" alt="zhaopin.jpeg">
      </div>
      <div class="nesc_cont1360 nesc_pos_bot">
        <h2 class="nesc_inban_title animate__animated animate__fadeInDown">{{ $t('lang.joinUs') }}</h2>
      </div>
    </div>

    <el-row type="flex" class="row-bg talent-txt" justify="center" :gutter="40" style="flex-wrap: wrap">
      <el-col :span="8" :xs="22">
        <div class="flex-column-left padding">
          <h1>{{ $t('lang.zhaoPinTitle1') }}</h1>
          <p>{{ $t('lang.zhaoPinContent1') }}</p>
        </div>

      </el-col>
      <el-col :span="8" :xs="22">
        <div class="flex-column-left padding">
          <h1>{{ $t('lang.zhaoPinTitle2') }}</h1>
          <p>{{ $t('lang.zhaoPinContent2') }}</p>
        </div>
      </el-col>
      <el-col :span="8" :xs="22">
        <div class="flex-column-left padding">
          <h1>{{ $t('lang.zhaoPinTitle3') }}</h1>
          <p>{{ $t('lang.zhaoPinContent3') }}</p>
        </div>
      </el-col>
    </el-row>

    <div class="nesc_cont1360" style="margin: 50px auto;">
      <h3 class="nesc_title40 nesc_about_title1  padding-top margin-bottom-xxl">{{ $t('lang.recruitment') }}</h3>
      <el-table v-loading="loading" class="talent-table" fit border :data="talentsList" stripe>
        <el-table-column prop="JobName" :label="$t('lang.jobTitle')" />
        <el-table-column prop="JobCategory" :label="$t('lang.jobCategories')" />
        <el-table-column prop="Amount" :label="$t('lang.numberOfRecruits')" />
        <el-table-column prop="Address" :label="$t('lang.workPlace')" />
        <el-table-column prop="PublishDate" :label="$t('lang.releaseDate')" />
        <el-table-column fixed="right" :label="$t('lang.operate')" width="100">
          <template slot-scope="scope">
            <router-link :to="{ name: 'recruitmentDetail', params: { id: scope.row.JobInfoId, time: scope.row.PublishDate}}">
              <el-button type="text" size="small">
                {{ $t('lang.check') }}
              </el-button>
            </router-link>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination :class="{hidePreBtn: curPage == 1, hideNextBtn: curPage == totalPage}" class="pcfy flex-row-center" hide-on-single-page :total="total" :page-size="pageSize" layout="prev, pager, next" @current-change="getTalents" @prev-click="getTalents" @next-click="getTalents" />

    <el-row class="phfy" type="flex" justify="space-around">
      <el-col :span="8">
        <a v-if="curPage> 1 " @click="getTalents(curPage - 1)">{{ $t('lang.previous') }}</a>
      </el-col>
      <el-col :span="8">
        <a v-if="curPage < totalPage" @click="getTalents(curPage + 1)">{{ $t('lang.next') }}</a>
      </el-col>
    </el-row>
  </el-container>
</template>

<script>
export default {
  name: 'Talent',
  data: () => {
    return {
      talentsList: [],
      pageSize: 15,
      curPage: 1,
      loading: !0,
      total: 0,
      totalPage: 0
    }
  },

  mounted() {
    this.getTalents(1)
  },

  methods: {
    getTalents(page) {
      this.loading = !0
      this.$http.post(this.isDevelop ? '/JobList' : '/api/JobInfoService/JobList', { page: page, limit: this.pageSize }).then(
        (response) => {
          response.statusText == 'OK' && response.data.data.length > 0 &&
            (this.talentsList = response.data.data || [], this.total = parseInt(response.data.count), this.loading = !1,
            this.totalPage = parseInt(response.data.count / this.pageSize) + 1)
        }
      ).catch(function() {
        this.talentsList = []
      })
    }
  }
}
</script>

<style lang="scss">
.pcfy {
  button {
    width: 40px;
    line-height: 40px;
    height: 40px;
    padding: 0 !important;
    margin: 0 5px !important;
  }
  button:hover {
    color: #EA6828 !important;
    background: url(../assets/image/menuselect.png) center / cover no-repeat;
  }
  .el-pager {
    li {
      width: 40px;
      line-height: 40px;
      height: 40px;
      padding: 0 !important;
      margin: 0 5px;
      font-family: Arial, Helvetica, sans-serif;
      font-size: 14px;
      font-weight: normal !important;
    }
    li.active {
      color: #EA6828;
      background: url(../assets/image/menuselect.png) center / cover no-repeat;
    }
    li:hover {
      color: #EA6828;
      background: url(../assets/image/menuselect.png) center / cover no-repeat;
    }
  }
}
.pcfy.hidePreBtn .btn-prev {
  visibility: hidden;
}
.pcfy.hideNextBtn .btn-next {
  visibility: hidden;
}
</style>

<style scoped lang="scss">
img {
  vertical-align: middle;
}
.t_neiban {
  position: relative;
}
.t_b1banpic {
  width: 100%;
}
.t_b1banpic img {
  width: 100%;
}

.nesc_pos_bot {
  position: absolute;
  bottom: auto;
  left: 50%;
  top: 50% ;
  transform: translate(-50%, -50%) !important;
}

.nesc_inban_title {
  font-size: 72px;
  line-height: 1.45;
  font-weight: bold;
  font-family: "OPPOSans2_En_design-Heavy", "OPPOSans2_En_design-Regular", "微软雅黑", Arial, "PingFangSC-Light", "Helvetica Neue", Helvetica, "Microsoft Yahei", "Hiragino Sans GB", tahoma, SimSun, sans-serif;
  color: rgba(87, 87, 87, 0.8);
}

.pcfy, .phfy {
  margin-top: 80px;
  margin-bottom: 50px;
}

.phfy .el-col {
  font-family: 微软雅黑;
  font-size: 14px;
  color: #333333;
  a {
    cursor:pointer;
  }
}
.phfy .el-col:first-of-type {
  text-align: left;
}
.phfy .el-col:last-of-type {
  text-align: right;
}

.talent-txt {
  background: rgb(247,248,250) ;
  padding: 60px 100px 40px;
}

.talent-txt .el-col p {
  padding-top: 30px;
  padding-bottom: 30px;
  font-size: 18px;
  line-height: 30px;
  color: #666666;
}

.talent-txt .el-col:nth-of-type(1) h1 {
  color: #63b455;
}
.talent-txt .el-col:nth-of-type(2) h1 {
  color: #2380cf;
}
.talent-txt .el-col:nth-of-type(3) h1 {
  color: #ebb563;
}

.talent-table {
  width: 80%;
  margin: 0 auto;
}

@media screen and (max-width: 1680px) {
  .nesc_inban_title {
    font-size: 64px;
  }
  .talent-table {
    width: 80%;
  }
}

@media screen and (max-width: 1440px) {
  .nesc_inban_title {
    font-size: 48px;
  }
  .talent-table {
    width: 90%;
  }
  .talent-txt .el-col p {
    font-size: 16px;
    line-height: 28px;
  }

}

@media screen and (max-width: 1024px) {
  .pcfy {
    display: none;
  }
  .phfy {
    display: flex !important;
  }
  .talent-txt {
    padding: 40px 10px 20px;
  }
}

@media screen and (max-width: 991px) {
  .talent-table {
    width: 100%;
  }
  .talent-txt {
    padding: 40px 10px 20px;
  }
}

@media screen and (max-width: 767px) {
  .talent-table {
    width: 100%;
  }
  .talent-txt .el-col p {
    padding-top: 5px;
    padding-bottom: 30px;
  }
  .talent-txt {
    padding-top:40px;
    padding-bottom: 20px;
  }
  .nesc_inban_title {
    font-size: 28px;
  }
}

@media screen and (min-width: 1024px) {
  .pcfy {
    display: flex !important;
  }
  .phfy {
    display: none;
  }
}

</style>
